import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/account_cancelled/$')({
  beforeLoad: legacyRedirect('/account_canceled'),
});
